module.exports = __webpack_public_path__ + "static/media/save_icon_competency.2c4ace05.svg";